import createListStore from "../stores/listStoreFactory";

export const useHoldingStore = createListStore('holding', )

export default useHoldingStore